/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true */

"use strict";

var R = require("ramda");

var pli = require("../core");

var defaultOptions;

/// <summary>
/// Default options that are used by every Pli.dialog.open.
/// Caller-provided options will override the default options.
/// </summary>


//-------------------------------------------
function getGeneralFeature(options, key, name, assignment, separator) {
    /// <summary>
    /// </summary>
    var value = options[key];
    if (value) {
        return name.concat(assignment, value, separator);
    }
    return "";
}


//-------------------------------------------
function getMeasurementFeature(options, key, name, assignment, separator) {
    /// <summary>
    /// </summary>
    var value = options[key];
    if (typeof value === "number") {
        return name.concat(assignment, value, "px", separator);
    }
    if (value) {
        return name.concat(assignment, value, separator);
    }
    return "";
}


//-------------------------------------------
function getBoolFeature(options, key, name, assignment, separator) {
    /// <summary>
    /// </summary>
    var value = options[key];
    if (typeof value === "boolean") {
        return name.concat(assignment, value ? "yes" : "no", separator);
    }
    if (value) {
        return name.concat(assignment, value, separator);
    }
    return "";
}


//-------------------------------------------
function buildDialogFeatures(options) {
    /// <summary>
    /// Build features string that can be passed
    /// to showModalDialog and showModelessDialog
    /// functions. Recognized options are ...
    /// </summary>
    return (
        "".concat(
            getBoolFeature(options, "center", "center", ":", ";"),
            getBoolFeature(options, "help", "help", ":", ";"),
            getBoolFeature(options, "resizable", "resizable", ":", ";"),
            getBoolFeature(options, "scroll", "scroll", ":", ";"),
            getBoolFeature(options, "status", "status", ":", ";"),
            getMeasurementFeature(options, "width", "dialogWidth", ":", ";"),
            getMeasurementFeature(options, "height", "dialogHeight", ":", ";"),
            getMeasurementFeature(options, "top", "dialogTop", ":", ";"),
            getMeasurementFeature(options, "left", "dialogLeft", ":", ";")
        )
    );
}


//-------------------------------------------
function buildWindowFeatures(options) {
    /// <summary>
    /// Build features string that can be passed
    /// to open function. Recognized options are ...
    /// </summary>
    return (
        "".concat(
            getBoolFeature(options, "channelmode", "channelmode", "=", ","),
            getBoolFeature(options, "fullscreen", "fullscreen", "=", ","),
            getBoolFeature(options, "location", "location", "=", ","),
            getBoolFeature(options, "menubar", "menubar", "=", ","),
            getBoolFeature(options, "resizable", "resizable", "=", ","),
            getBoolFeature(options, "scroll", "scrollbars", "=", ","),
            getBoolFeature(options, "status", "status", "=", ","),
            getBoolFeature(options, "toolbar", "toolbar", "=", ","),
            getGeneralFeature(options, "width", "width", "=", ","),
            getGeneralFeature(options, "height", "height", "=", ","),
            getGeneralFeature(options, "top", "top", "=", ","),
            getGeneralFeature(options, "left", "left", "=", ",")
        )
    );
}


//-------------------------------------------
function addWindowDimensions(wnd, container) {
    var htmlNode;

    if (wnd) {
        if (typeof wnd.innerWidth === "number") { // Non-IE
            container.width = wnd.innerWidth;
            container.height = wnd.innerHeight;
            return container;
        }
        if (wnd.document && wnd.document.body) { // IE 4+ compatible
            htmlNode = wnd.document.body.parentNode;
            if (htmlNode && typeof htmlNode.offsetWidth === "number") {
                container.width = htmlNode.offsetWidth;
                container.height = htmlNode.offsetHeight;
                return container;
            }
        }
    }
    container.width = -1;
    container.height = -1;
}


//-------------------------------------------
function openDialog(options, wnd) {
    /// <summary>
    /// </summary>
    var windowType, url, args, position, topWindow, regInfo,
        dialogRegistry = pli.dialogRegistry;

    options = R.merge(defaultOptions, options || {});
    url = ((!options.targetUrl || options.useLoader) ? pli.resolveUrl("~/Pli/DialogLoader.html") : pli.resolveUrl(options.targetUrl)); // decide whether to use dialog loader or specified URL
    args = { parentPli: pli, options: options };

    if (options.dialogId && dialogRegistry) { // if dialog registry is present and the new dialog is identifiable, register the new dialog now
        regInfo = dialogRegistry.find(options.dialogId);
        if (regInfo && regInfo.pli && regInfo.pli.dialogFocus) { // already registered with window opened and focuseable
            regInfo.pli.dialogFocus();
            return regInfo.pli.loaderWindow;
        }
        url = dialogRegistry.setDialogId(url, options.dialogId, options.useQueryString);
        dialogRegistry.register(options.dialogId, { options: options });
    }

    wnd = wnd || window;
    windowType = options.windowType || "modal";
    switch (windowType.toLowerCase()) {
    case "modal":
        return wnd.showModalDialog(url, args, buildDialogFeatures(options));

    case "modeless":
        return wnd.showModelessDialog(url, args, buildDialogFeatures(options));

    case "window":
        topWindow = pli.rootPli.loaderWindow;
        position = {
            x: topWindow.screenLeft || topWindow.screenX || 0,
            y: topWindow.screenTop || topWindow.screenY || 0
        };
        addWindowDimensions(topWindow, position);
        if (!options.hasOwnProperty("left")) {
            options.left = Math.max(0, position.x + Math.ceil((position.width - options.width) / 2));
        }
        if (!options.hasOwnProperty("top")) {
            options.top = Math.max(0, position.y + Math.ceil((position.height - options.height) / 2) - 40); // "40" is a Bulgarian constant (account a little bit for browser chrome)
        }
        return wnd.open(url, "_blank", buildWindowFeatures(options));
    }
}


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


// determine default options (immediately on load)
defaultOptions = R.merge(
    { // hard-coded defaults (will be overriden by pli.config's "clientDefaultOptions", if any)
        windowType: "modal",
        width: 800,
        height: 600,
        resizable: false,
        center: true,
        scroll: false,
        status: false,
        help: false
    },
    pli.config.clientDefaultOptions || {}
);


// return object that will become Pli.dialog
module.exports = {

    open: openDialog
    /// <summary>
    /// Open a new dialog window (modal, modeless or window).
    /// </summary>

};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms/Dialog.js
// module id = 383
// module chunks = 49